/**
 * @generated SignedSource<<0d9eccf9cb64925e3a14cb7e90dbe0da>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type BioV2_userProfile$data = {
  readonly bio: string | null;
  readonly visitorCanEdit: boolean;
  readonly " $fragmentType": "BioV2_userProfile";
};
export type BioV2_userProfile$key = {
  readonly " $data"?: BioV2_userProfile$data;
  readonly " $fragmentSpreads": FragmentRefs<"BioV2_userProfile">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "BioV2_userProfile",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "bio",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "visitorCanEdit",
      "storageKey": null
    }
  ],
  "type": "UserProfile",
  "abstractKey": null
};

(node as any).hash = "8ecfef2fe8a8010ec1897f930719203e";

export default node;
